module.exports = __webpack_public_path__ + "v.no2.42549360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/v.no2.jpg
// module id = X8zW
// module chunks = 0